module.exports = __webpack_public_path__ + "src/img/artist/indexpic02.jpg?b0d85e269090850faf0911104728cee1";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/indexpic02.jpg
// module id = 129
// module chunks = 0